<template>
  <div v-if="transactions.length" class="table-responsive">
    <table class="table align-middle">
      <thead>
      <tr>
        <th>Название</th>
        <th>Сумма</th>
        <th>Категория</th>
        <th>Дата</th>
        <th>Гео</th>
        <th>Изменить</th>
        <th>Удалить</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="t in transactions" :key="t.id" :id="t.id">
        <th scope="row">{{ t.name }}</th>
        <td>{{ t.amount < 0 ? getCurrencyFormatted(t.amount, accountCurrency) : '+' + getCurrencyFormatted(t.amount, accountCurrency) }}</td>
        <td>{{ t.categoryName }}</td>
        <td>{{ formatLocal(t.createdAt) }}</td>
        <td>
          <button
              class="btn btn-sm"
              :hidden="!t.latitude || !t.longitude"
              :disabled="!t.latitude || !t.longitude"
              @click="emit('openMap', {
              latitude: t.latitude,
              longitude: t.longitude
            }, false)"
          >
            📍 Geo
          </button>
        </td>
        <td>
          <button class="btn btn-sm btn-primary" @click="emit('update', t)">Изменить</button>
        </td>
        <td>
          <button class="btn btn-sm btn-danger" @click="emit('delete', t)">Удалить</button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div v-else class="muted g-3 mt-3">
    <p>Нет транзакций</p>
  </div>
</template>

<script setup>
import { formatLocal } from '@/api/helpers';
import {getCurrencyFormatted} from "@/api/helpers";

const props = defineProps({
  transactions: { type: Array, required: true },
  accountCurrency: { type: String, required: true },
});
const emit = defineEmits(['update, delete', 'openMap']);
</script>
